import React from "react";
import Logo from "./Logo";
import SidebarNav from "./SidebarNav";
import SupportSection from "./SupportSection";

const Sidebar = ({ onLogout }) => {
  return (
    <div className="smai-sidebar">
      <Logo />
      <SidebarNav />
      <SupportSection />
      <div className="smai-logout-button-container">
        <button className="smai-logout-button" onClick={onLogout}>
          <span className="smai-logout-icon"></span>
          <span>Log Out</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
